import type { DatabaseBackup } from '@/entities/database';
import request from '@/shared/api/request';

export const getDatabaseBackups = (uuid: string): Promise<{ backups: DatabaseBackup[] }> =>
  request({
    url: `/databases/${uuid}/backups`,
  });
